import { IeLynxObject } from "../../common/models/eLynxObject";
import { IDateRange } from "../../common/models/IDateRange";
import { ITrendingDisplayOptions } from "../../services/trending-data-service/Models";

export const keys = {
    all: ["tank-battery"],
    graphDatas: () => [
        ...keys.all,
        "graph-data"
    ],
    graphData: (
        contextGroupID: number,
        eLynxObject: IeLynxObject | undefined,
        dateRange: IDateRange,
        displayOptions?: ITrendingDisplayOptions
    ) => [
            keys.graphDatas(),
            {
                contextGroupID,
                eLynxObject,
                dateRange,
                displayOptions
            }
        ]
};